import FormatPrice from "core-web/components/FormatPrice";
import PropTypes from "prop-types";
import React from "react";
import Row from "theme/layouts/Row";
import TextStyles from "theme/components/text/TextStyles";
import colors from "theme/config/colors";
import discountInPercentage from "core-web/utils/discountInPercentage";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Price = ({
    price = null,
    priceExVat = 0,
    showFromPrice,
    originalPriceExVat = 0,
    standardPriceExVat = 0,
    vatRate = 1,
    textStyles,
    priceListId,
    priceListCode,
    skipValidateDiscountPercentage,
    skipDiscountCheck,
    ...rest
}) => {
    const { t } = useTranslation();
    const { id: defaultPricelistId, code: defaultPriceListCode } =
        useSelector(({ application }) => application?.defaultPriceList) || {};
    let standardPriceExVatToDisplay = standardPriceExVat;

    // If priceListId or priceListCode is passed, check dem against default pricelist
    // to determine if product actually is on sale
    let hasCampaignPriceList = true;
    if (priceListId) {
        hasCampaignPriceList = priceListId !== defaultPricelistId;
    }
    if (priceListCode) {
        hasCampaignPriceList = priceListCode !== defaultPriceListCode;
    }

    if (!hasCampaignPriceList && originalPriceExVat) {
        hasCampaignPriceList = true;
        standardPriceExVatToDisplay = originalPriceExVat;
    }

    // @todo: discount in percentage rule should maybe be set i cms

    const onSale =
        (hasCampaignPriceList || skipDiscountCheck) &&
        !!(
            standardPriceExVatToDisplay &&
            ((!skipValidateDiscountPercentage && standardPriceExVatToDisplay > priceExVat) ||
                discountInPercentage(standardPriceExVatToDisplay, priceExVat) > 1)
        );

    const formatProps = {
        separateWith: " ",
        render: (price) => t("price_with_currency", { price }),
    };

    return (
        <Row gap="10px" {...rest}>
            <TextStyles as={onSale ? "ins" : "p"} textStyles={textStyles}>
                <FormatPrice {...formatProps} vatRate={vatRate} price={price || priceExVat} />
            </TextStyles>
            {onSale && (
                <TextStyles as="del" textStyles={textStyles} color={onSale && colors.neutral_400}>
                    <FormatPrice {...formatProps} price={standardPriceExVatToDisplay} vatRate={vatRate} />
                </TextStyles>
            )}
        </Row>
    );
};

Price.propTypes = {
    priceExVat: PropTypes.number.isRequired,
    priceListCode: PropTypes.string,
    priceListId: PropTypes.number,
    showFromPrice: PropTypes.bool,
    skipDiscountCheck: PropTypes.bool,
    skipValidateDiscountPercentage: PropTypes.bool,
    standardPriceExVat: PropTypes.number,
    originalPriceExVat: PropTypes.number,
    textStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    vatRate: PropTypes.number,
};

Price.defaultProps = {
    priceListCode: null,
    priceListId: null,
    showFromPrice: false,
    skipDiscountCheck: false,
    skipValidateDiscountPercentage: false,
    standardPriceExVat: 0,
    originalPriceExVat: 0,
    textStyles: ["Myriad Pro/16-100", null, null, "Myriad Pro/18-100"],
    vatRate: 1,
};

export default Price;
